




















import { Vue, Prop, Component } from 'vue-property-decorator';
import { ProductTileViewObject } from '@/types/apiServerContract';
import ProductListTracker from '@/project/tracking/gtm/ProductListTracker.vue';
import serverContext from '@/core/serverContext.service';
import AdnuntiusProductBannerBlock from '@/project/app/blocks/AdnuntiusProductBannerBlock.vue';

@Component({
    components: { AdnuntiusProductBannerBlock, ProductListTracker }
})
export default class SearchProductResultList extends Vue {
    @Prop({ type: Array, required: true })
    private products!: ProductTileViewObject[];

    @Prop({ required: true, type: String })
    private trackingListName!: string;

    @Prop({ required: true, type: String })
    private brandName!: string;

    @Prop({ type: String, required: true })
    private contextKey!: string;

    @Prop({ type: Number, required: true })
    private pageId!: number;

    private get isBannerAllowedOnPage() {
        return this.pageId % 2 === 1;
    }

    private get placementIndex(): number {
        const index = serverContext.settings?.productListContentPlacementIndex ?? -1;
        return index > 0 ? Math.max(0, index - 1) : index;
    }

    private showProductContentAtIndex(index: number) {
        if (this.placementIndex < 0) return false;

        // If wanted placement is higher than result count, then place it at the end
        const maxIndex = this.products.length - 1;
        if (maxIndex <= this.placementIndex) {
            return index === maxIndex;
        }

        return index === this.placementIndex;
    }
}
